import React, { createRef } from 'react';
import cn from 'classnames';
import { SectorCell, BondNameCell, StatusCell, AgingCell } from '@/creditflowresearch/ui/common/components/TableCells';
import { BodyCellPure } from '@creditflowresearch/uilib/Table/DataTable/Body/BodyCell';
import {
  getCeCell,
  getCurrentFaceCell,
  getDealerCell,
  getIdentifierCell,
  getOriginalFaceCell,
  getOtherRatingCell,
  getRatingCell,
  getSpeedCell,
  getSpreadCell,
  getWalCell,
  getPriceCell,
  getAddedAtCell,
  getIsNewCell,
} from '../../cellCallbacks';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import styles from '@/creditflowresearch/ui/components/bonds/common/BondTables/bondsTables.module.scss';

interface IProps {
  row: object,
  rowIndex: number,
  isNewColumnVisible: boolean,
}

const InventoryRow = ({
  row,
  rowIndex,
  isNewColumnVisible,
}: IProps) => {
  const rowRef = createRef<React.LegacyRef<HTMLElement> | null>();

  const handleMouseEnter = () => {
    const node = rowRef.current;

    if (node) {
      // @ts-ignore
      node.querySelector('.togglerCheckbox').checked = false;
    }
  };

  // take 2 columns if isNew column is visible
  const identifierColspan = isNewColumnVisible ? 2 : 1;

  return (
    <tr
      // @ts-ignore
      ref={ rowRef }
      onMouseEnter={ handleMouseEnter }
      className={ styles.row }
    >
      <BodyCellPure
        name="status"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ StatusCell }
      />
      <BodyCellPure
        name="sector"
        className={ alignStyles.alignLeft }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ SectorCell }
      />
      <BodyCellPure
        name="name"
        className={ alignStyles.alignLeft }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ BondNameCell }
      />
      <BodyCellPure
        name="originalFace"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getOriginalFaceCell }
      />
      <BodyCellPure
        name="currentFace"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getCurrentFaceCell }
      />
      <BodyCellPure
        name="wal"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getWalCell }
      />
      <BodyCellPure
        name="ratingMoodys"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingSAndP"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingFitch"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingDBRS"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingKroll"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingOtherOrUnspecified"
        className={ alignStyles.alignCenter }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getOtherRatingCell }
      />
      <BodyCellPure
        name="spread"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getSpreadCell }
      />
      <BodyCellPure
        name="speed"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getSpeedCell }
      />
      <BodyCellPure
        name="ce"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getCeCell }
      />
      <BodyCellPure
        name="price"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getPriceCell }
      />
      <BodyCellPure
        name="dealer"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getDealerCell }
      />
      <BodyCellPure
        name="aging"
        className={ alignStyles.alignRight }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ AgingCell }
      />
      <BodyCellPure
        name="identifier"
        className={
          cn(styles.identifierCell, alignStyles.alignRight, spacesStyles.ptn, spacesStyles.pbn, spacesStyles.prl)
        }
        colSpan={ identifierColspan }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getIdentifierCell }
      />
      <BodyCellPure
        name="addedAt"
        className={ cn(styles.addedAtCell, alignStyles.alignRight) }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getAddedAtCell }
      />
      <BodyCellPure
        name="isNew"
        className={ cn(styles.isNewCell, alignStyles.alignCenter) }
        rowIndex={ rowIndex }
        rowData={ row }
        cellCallback={ getIsNewCell }
        isVisible={ isNewColumnVisible }
      />
    </tr>
  );
};

export default InventoryRow;
